import type { StatsOverviewFieldsFragment } from './queries.generated';

type Stats = Pick<StatsOverviewFieldsFragment, 'restaurants' | 'externalOrderTotalsBySource'>;

export function thirdPartyPayoutSummary(stats: Stats | undefined) {
  const externalOrderTotalsBySource = stats?.externalOrderTotalsBySource ?? [];

  return {
    hasActiveStreamConnection:
      stats?.restaurants.some((restaurant) => restaurant.hasActiveStreamLocationConnection) ??
      false,
    externalOrderTotal: externalOrderTotalsBySource.reduce(
      (total, source) => total + source.amount,
      0,
    ),
  };
}
